import ReactComponent from '../app/ReactComponent'

import {
  AP_ADDITIONAL_ADDRESS_TYPE_ID,
  AP_AGREEMEMT_TYPE_ID
} from '../helpers/misc'

import {
  Button,
  Card,
  Col,
  Divider,
  Form,
  Input,
  Layout,
  Result, Row,
  Select, Space,
  Spin, Switch,
  Tooltip, Typography
} from 'antd'
import {Link} from 'react-router-dom'
import {ArrowRightOutlined, CaretDownOutlined, DownOutlined, InfoCircleOutlined, UpOutlined} from '@ant-design/icons'
import {GDPRModal} from '../components/form/GDPRModal'
import React, {createRef} from 'react'
import {getAddressTypeNameByAddressTypeId} from '../services/addresses'
import {fixZIP} from '../helpers/utils'
import App from '../app/App'
import {MarketingCommunicationModal} from '../components/form/MarketingCommunicationModal'
import Empty from 'antd/es/empty/empty'
import {PROPERTY_AP_INSURANCE_KEY, PROPERTY_AP_JOB_KEY, PROPERTY_AP_NIN, PROPERTY_AP_PRACTITIONER_KEY, PROPERTY_AP_SOCIAL_ID_KEY} from '../helpers/properties'
import {ProfilingModal} from '../components/form/ProfilingModal'
import {getInsuranceCompany, getJobProperty, getNationalId, getPractitioner, getSocialId} from '../services/properties'

const emptyData = <div className="empty-data"><Empty/>
  <div>Žádná data nejsou k dispozici</div>
</div>

export class ProfileUpdateOtherPage extends ReactComponent {
  accountFormRef = createRef()

  state = {
    loading_page: false,
    constants: {
      AP_AGREEMEMT_TYPE_ID
    },
    account: {},
    account_properties: {
      job: null,
      practitioner: null,
      social_id: null,
      insurance_company: null,
      national_id: null
    },
    contact_address: null,
    arrived_alert: false,
    agreement_label: 'Souhlas se zpracováním osobních údajů',
    agreement_text: false,
    agreement_marketing_communication: null,
    insurance_companies: [],
    jobs: []
  }

  async componentDidMount() {

    this.scrollToTop()

    this.pushPageAnalytics('Přidání doplňujících informací o vás - Moje Amber')

    void this.updateState({loading_page: true})

    void this.getDataForForm()

  }

  async getDataForForm() {
    const countries = await this.$app.$store('common').getCountries()
    const address_types = await this.$app.$store('account').getAddressTypes()
    const addresses = await this.$app.$store('account').getAddresses()
    const account = await this.$app.$store('account').getPersonalInfo()
    const properties = await this.$app.$store('account').getProperties()

    const contact_address = addresses.find(({address_type}) => address_type === AP_ADDITIONAL_ADDRESS_TYPE_ID) ?? null

    const {bookings: arrived_bookings = []} = await this.$api({
      action: 'carecloud_api',
      route: `bookings?booking_statuses[]=${this.state.constants.AP_BOOKING_STATUS_ARRIVED_ID}`
    })

    const {name: agreement_label = false, text: agreement_text = false} = await this.$api({
      action: 'carecloud_api',
      route: `agreements/${this.state.constants.AP_AGREEMEMT_TYPE_ID}`
    })

    const {items: insurances = []} = await this.$api({
      action: 'carecloud_api',
      route: `customer-properties/${PROPERTY_AP_INSURANCE_KEY}`
    })

    const {items: jobs = []} = await this.$api({
      action: 'carecloud_api',
      route: `customer-properties/${PROPERTY_AP_JOB_KEY}`
    })

    await this.updateState({
      loading_page: false,
      account,
      account_properties: {
        job: getJobProperty(properties),
        practitioner: getPractitioner(properties),
        social_id: getSocialId(properties),
        insurance_company: getInsuranceCompany(properties),
        national_id: getNationalId(properties)
      },
      contact_address,
      countries: countries,
      address_types: address_types,
      addresses: addresses,
      arrived_alert: !!arrived_bookings.length,
      agreement_label: (agreement_label ?? this.state.agreement_label),
      agreement_text: (agreement_text ?? this.state.agreement_text),
      agreement_marketing_communication: account.agreement_mc,
      agreement_profiling: account.agreement_profiling,
      agreement_gtc: account.agreement_gtc,
      insurance_companies: insurances,
      jobs,
    })

    this.valuesForFormItems()

  }

  valuesForFormItems() {

    this.accountFormRef.current.setFieldValue('insurance', this.state.account_properties.insurance_company)
    this.accountFormRef.current.setFieldValue('social_id', this.state.account_properties.social_id)
    this.accountFormRef.current.setFieldValue('practitioner', this.state.account_properties.practitioner)
    this.accountFormRef.current.setFieldValue('job', this.state.account_properties.job)
    this.accountFormRef.current.setFieldValue('national_id', this.state.account_properties.national_id)

    this.accountFormRef.current.setFieldValue('city', this.state.account.city)
    this.accountFormRef.current.setFieldValue('descnumber', this.state.account.descnumber)
    this.accountFormRef.current.setFieldValue('street', this.state.account.street)
    this.accountFormRef.current.setFieldValue('zip', this.state.account.zip)
    this.accountFormRef.current.setFieldValue('orientnumber', this.state.account.orientnumber)
    this.accountFormRef.current.setFieldValue('agreement_marketing_communication', !this.state.agreement_marketing_communication)

    if(this.state.contact_address) {
      this.accountFormRef.current.setFieldValue('contact_city', this.state.contact_address.address.city)
      this.accountFormRef.current.setFieldValue('contact_street', this.state.contact_address.address.address1)
      this.accountFormRef.current.setFieldValue('contact_descnumber', this.state.contact_address.address.address2)
      this.accountFormRef.current.setFieldValue('contact_orientnumber', this.state.contact_address.address.address3)
      this.accountFormRef.current.setFieldValue('contact_zip', this.state.contact_address.address.zip)
    }


  }

  async sendFormData(data) {

    void this.updateState({loading_page: true})

    try {

      const {personal_information} = await this.$api({
        action: 'carecloud_user_api',
        route: ''
      })

      const agreement_gtc = +(this.state.agreement_gtc)
      const agreement_profiling = +(this.state.agreement_profiling)
      const agreement_marketing_communication = +(this.state.agreement_marketing_communication)

      if(!agreement_gtc) throw 'Souhlas se zpracováním osobních údajů je povinný.'


      const property_records = [
        data.job          && { property_id: PROPERTY_AP_JOB_KEY,          property_value: [{ id: data.job }] },
        data.practitioner && { property_id: PROPERTY_AP_PRACTITIONER_KEY, property_value: data.practitioner },
        data.social_id    && { property_id: PROPERTY_AP_SOCIAL_ID_KEY,    property_value: data.social_id },
        data.insurance    && { property_id: PROPERTY_AP_INSURANCE_KEY,    property_value: [{ id: data.insurance }] },
        data.national_id  && { property_id: PROPERTY_AP_NIN,              property_value: data.national_id },
      ].filter(Boolean);

      await this.$api({
        action: 'carecloud_user_api',
        method: 'PUT',
        data: {
          customer: {
            personal_information: {
              ...personal_information,
              address: {
                address1: data.street,
                address2: data.descnumber,
                address3: data.orientnumber,
                city: data.city,
                zip: fixZIP(data.zip),
                country_code: this.state.account.country_code
              },
              agreement: {
                agreement_gtc: agreement_gtc,
                agreement_profiling: agreement_profiling,
                agreement_marketing_communication: agreement_marketing_communication
              },
              language_id: this.state.account.language_id
            }
          },
          property_records
        }
      })

      if(data.contact_city ||
        data.contact_descnumber ||
        data.contact_orientnumber ||
        data.contact_street ||
        data.contact_zip)
        {
          await this.sendContactAddressData(data, AP_ADDITIONAL_ADDRESS_TYPE_ID)
        }


      const account = await this.$app.$store('account').getPersonalInfo(true)

      await this.updateState({
        account: account
      })

      App.$toast('Údaje byly aktualizovány.')

    } catch (error) {

      this.handleError(error)

    } finally {

      void this.updateState({loading_page: false})

    }

  }

  async sendContactAddressData(data, address_type_id) {

    void this.updateState({loading_page: true})

    try {

      data = {
        additional_address: {
          address_type: address_type_id,
            address: {
              address1: data.contact_street,
              address2: data.contact_descnumber,
              address3: data.contact_orientnumber,
              city: data.contact_city,
              zip: fixZIP(data.contact_zip),
              country_code: 'cz'
          }
        }
      }

      if(this.state.contact_address) {
        await this.$api({
          action: 'carecloud_user_api',
          route: `addresses/${this.state.contact_address.additional_address_id}`,
          method: 'PUT',
          data
        })
      } else {
        await this.$api({
          action: 'carecloud_user_api',
          route: `addresses`,
          method: 'POST',
          data
        })
      }

      // refresh addresses
      //await this.getAddresses()

      //this.$toast.success(this.$t('notices.successfully_updated'))

    } catch (error) {

      console.log(error)

    } finally {

      void this.updateState({loading_page: false})

    }

  }

  getAddressTypeName(id) {

    return getAddressTypeNameByAddressTypeId(this.address_types, id, this.$tc('common.unknown', 2))

  }

  render() {
    return (
      <Layout tagName="main" className={'page-with-title ' + (this.state.gender === 2 ? 'female' : 'male')}>
        <Row align="center" className="margin-auto">
          <Col xs={23}>
            <Spin spinning={this.state.loading_page} size="large">
              <Card bordered={false} style={{maxWidth: 680}} className="card register">
                {this.state.complete && <Result
                  status="success"
                  title="Registrace byla úspěšná."
                  subTitle="Odkaz pro nastavení hesla Vám přijde na e-mail."/>
                }
                {!this.state.ongoing_alert &&
                  !this.state.blocked_alert &&
                  !this.state.complete &&

                  <Form
                    ref={this.accountFormRef}
                    layout="horizontal"
                    labelCol={{span: 7}}
                    wrapperCol={{span: 17}}
                    onFinish={(...args) => this.sendFormData(...args)}>

                    <h2 className="mb-0 _secondary-text">Přidání doplňujících<br/>informací o vás</h2>

                    <div className="form-container">
                      <div className="speech helper-text mt-3 mb-3">
                        <p className="_secondary-text strong mt-0 mb-1">Chcete zkrátit čas v dárcovském centru?</p>
                        <p className="mt-1 mb-0">Vyplněním doplňujících údajů to zvládnete rychleji. Není to povinné, ale pomůže to.</p>
                      </div>
                    </div>

                    <div className="form-container">

                      <Form.Item label="Pojišťovna" name="insurance" className="flex-start select-full-width">
                        <Select
                          placeholder="Vyberte vaši pojišťovnu"
                          suffixIcon={<CaretDownOutlined className="ant-select-suffix"/>}
                          size="large"
                          notFoundContent={emptyData}

                          options={this.state.insurance_companies.map(item => ({
                            label: item.name,
                            value: item.id
                          }))}/>
                      </Form.Item>

                      <Form.Item label="Rodné číslo" name="social_id">
                        <Input placeholder="Zadejte vaše rodné číslo" size="large"/>
                      </Form.Item>

                      <Form.Item label="Ulice" name="street" className="GoogleAutocompleteAddressTrigger">
                        <Input placeholder="Zadejte ulici vašeho bydliště" size="large"/>
                      </Form.Item>

                      <Form.Item label="Číslo popisné / orientační" className="contact-descnumber flex-start">
                        <Form.Item name="descnumber" style={{display: 'inline-block', width: 100}}>
                          <Input placeholder="" size="large"/>
                        </Form.Item>
                        <span>/</span>
                        <Form.Item name="orientnumber" style={{display: 'inline-block', width: 100}}>
                          <Input placeholder="" size="large"/>
                        </Form.Item>
                      </Form.Item>

                      <Form.Item label="Město" name="city">
                        <Input placeholder="Zadejte vaše město" size="large"/>
                      </Form.Item>

                      <Form.Item label="PSČ" name="zip" className="flex-start">
                        <Input placeholder="123 45" size="large" style={{width: 100}}/>
                      </Form.Item>

                      <Form.Item label="Praktický lékař" name="practitioner">
                        <Input placeholder="Jméno lékaře nebo zařízení" size="large"/>
                      </Form.Item>

                      <Form.Item label="Povolání" name="job">
                        <Select
                          placeholder="Vyberte vaše povolání"
                          suffixIcon={<CaretDownOutlined className="ant-select-suffix"/>}
                          size="large"
                          notFoundContent={emptyData}
                          options={this.state.jobs.map(item => ({
                            label: item.name.split(" - ").slice(0, 2).join(", "),
                            value: item.id
                          }))}/>
                      </Form.Item>

                      <Form.Item label="Číslo pojištěnce" name="national_id">
                        <Input placeholder="Zadejte číslo pojištěnce" size="large" suffix={
                          <Tooltip
                            title="Číslo pojištěnce vyplňte pouze pokud nemáte Rodné číslo nebo pokud je Vaše Číslo pojištěnce jiné než Rodné číslo.">
                            <InfoCircleOutlined style={{color: 'rgba(0,0,0,.45)'}}/>
                          </Tooltip>
                        }/>
                      </Form.Item>
                    </div>


                    <Button type="primary" className="btn-collapsible mt-2 mb-2" onClick={() => {
                      void this.updateState({contact_address: !this.state.contact_address})
                    }}>Kontaktní adresa {!this.state.contact_address ? <DownOutlined/> : <UpOutlined/>}</Button>


                    {!this.state.contact_address &&
                      <div className="form-container mt-2">
                        <div className="speech helper-text">
                          <p className="ma-0">Vyplňte vaší kontaktní adresu, pokud se liší od standardní adresy.</p>
                        </div>
                      </div>
                    }

                    {this.state.contact_address &&

                      <div className="contact-address">
                        <Form.Item label="Ulice" name="contact_street" className="GoogleAutocompleteAddressTrigger">
                          <Input placeholder="Zadejte část adresy" size="large"/>
                        </Form.Item>

                        <Form.Item label="Číslo popisné / orientační" className="contact-descnumber flex-start">
                          <Form.Item name="contact_descnumber"
                                     style={{display: 'inline-block', width: 100}}>
                            <Input placeholder="" size="large"/>
                          </Form.Item>
                          <span style={{margin: 'auto 5px'}}>/</span>
                          <Form.Item name="contact_orientnumber"
                                     style={{display: 'inline-block', width: 100}}>
                            <Input placeholder="" size="large"/>
                          </Form.Item>
                        </Form.Item>

                        <Form.Item label="Město" name="contact_city">
                          <Input placeholder="" size="large"/>
                        </Form.Item>

                        <Form.Item label="PSČ" name="contact_zip" className="flex-start">
                          <Input placeholder="" size="large" style={{width: 100}}/>
                        </Form.Item>
                      </div>

                    }

                    <Divider orientation="center" plain className="mt-3">
                      <Link to="/survey">
                        <Button type="primary" className="btn-collapsible">Vyplnit dotazník <ArrowRightOutlined className="strong"/></Button>
                      </Link>
                    </Divider>

                    <div className="form-container">
                      <div className="speech helper-text mt-3">
                        <p className="_secondary-text strong mt-0 mb-2">Chcete zkrátit čas v dárcovském centru?</p>
                        <p className="mb-2 mt-1">Vyplněním dotazníků si významně zkrátíte čas, který byste strávili vyplněním otázek v odběrovém centru. Není to povinné, ale pomůže to.</p>
                        <p className="strong">Platnost vyplněného dotazníku je 48 hodin, nevyplňujte dříve než 48 hodin před Vašim odběrem!</p>
                      </div>
                    </div>

                    <div className="form-container">

                      <Form.Item className="consent mb-0">
                        <Form.Item name="agreement_gtc" className="switch-container">
                          <Switch
                            id="agreement_gtc"
                            checked={this.state.agreement_gtc}
                            onChange={(data) => {
                              void this.updateState({agreement_gtc: data})
                            }}
                            style={{marginRight: '0.9em'}}/>
                        </Form.Item>
                        <label htmlFor="agreement_gtc">Souhlasím se zpracováním svých osobních údajů za účelem vedení evidence opakovaných dárců a jejich odběrů, odměn a bonusů a související komunikace s dárci <GDPRModal/>
                        </label>
                      </Form.Item>

                      <Form.Item className="consent">
                        <Form.Item
                          name="agreement_profiling"
                          className="switch-container">
                          <Switch
                            id="agreement_profiling"
                            checked={this.state.agreement_profiling}
                            onChange={(data) => {
                              void this.updateState({agreement_profiling: data})
                            }}
                            style={{marginRight: '0.9em'}}/>
                        </Form.Item>
                        <label htmlFor="agreement_profiling" className="required">Souhlasím se zpracováním svých osobních údajů za účelem profilování <ProfilingModal/>
                        </label>
                      </Form.Item>

                      <Form.Item className="consent">
                        <Form.Item
                          name="agreement_marketing_communication"
                          className="switch-container"
                        >
                          <Switch
                            id="agreement_marketing_communication"
                            checked={!this.state.agreement_marketing_communication}
                            style={{marginRight: '0.9em'}}
                            onChange={(data) => {
                              void this.updateState({agreement_marketing_communication: !data})
                            }}/>
                        </Form.Item>
                        <label htmlFor="agreement_marketing_communication" className="required">Nesouhlasím s marketingovou komunikací (zasíláním obchodních sdělení) <MarketingCommunicationModal/></label>
                      </Form.Item>

                    </div>

                    <Row align="center">
                      <Col xs={24} md={20}>
                        <Typography.Paragraph type="secondary" style={{margin: '1em 1em 0'}} className="text-info">Vyplněním výše uvedeného formuláře a kliknutím na pole "Registrovat" potvrzuji, že jsem se seznámil/a s informacemi o zpracování osobních údajů, které jsou dostupné <a href="https://www.amberplasma.com/file/1144" rel="noreferrer" target="_blank">zde</a>.
                        </Typography.Paragraph>
                      </Col>
                    </Row>

                    <Space style={{marginTop: '30px'}} size={[12, 10]} className="btn-container">

                      <Button htmlType="submit" type="primary" className="btn _ternary" icon={<Spin spinning={this.state.loading_page}/>}>Aktualizovat informace</Button>
                    </Space>

                  </Form>
                }
              </Card>
            </Spin>
          </Col>
        </Row>

      </Layout>
    )
  }
}